import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {Router} from '@angular/router';
import {RowEntry} from '../models';

@Component({
    selector: 'edu-udo-itmc-dev-mini-book-timetable-display',
    templateUrl: './timetable-display.component.html',
    styleUrls: ['./timetable-display.component.css'],
    standalone: false
})
export class TimetableDisplayComponent implements OnInit {

  @Input()
  entries: RowEntry[] = [];

  @Input()
  showInternalLink: boolean = false;

  timetableEntries: TimetableEntry[] = [];
  noteNumberMap: Map<number, number> = new Map();
  entryNotes: {number: number, text: string}[] = [];

  days: Array<Date> = [];
  hours: number[] = [];
  offsetHours: number[] = [];

  rowsPerHour: number = 12;
  rowOffset: number = this.rowsPerHour;

  gridStyle = "auto"

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateData();
  }

  updateData() {
    this.setHours();
    this.setDays();

    this.timetableEntries = [];
    this.entries.forEach(entry => {
      this.timetableEntries.push(new TimetableEntry(entry, this.getRow(entry), this.getColumn(entry)));
    });

    // Assign note numbers [1], [2], ... to entries with notes
    this.noteNumberMap = new Map();
    this.entryNotes = [];
    let noteCounter = 0;
    this.entries.forEach(entry => {
      const note = entry.entry.notes;
      if (note && note.trim().length > 0) {
        noteCounter++;
        this.noteNumberMap.set(entry.entry.id, noteCounter);
        this.entryNotes.push({number: noteCounter, text: note});
      }
    });

    this.gridStyle = this.createGridStyle();
  }

  createGridStyle(): string {
    let style = "auto";

    this.hours.forEach(time => {
      if (this.offsetHours.includes(time)) {
        style += ` repeat(${this.rowsPerHour},1fr)`;
      }
      else {
        style += ` repeat(${this.rowsPerHour},auto)`;
      }
    });
    this.offsetHours = [];

    return style;
  }

  setDays() {
    this.days = [];
    let stringDates: string[] = [];

    this.entries.forEach(entry => {
      if (!stringDates.includes(entry.timeslot.date.toString())) {
        stringDates.push(entry.timeslot.date.toString());
        this.days.push(entry.timeslot.date);
      }
    });

    this.days.sort((a, b) => {
      return a.valueOf() - b.valueOf();
    });
  }

  setHours() {
    this.hours = [];
    let hours: number[] = [];

    this.entries.forEach(entry => {
      hours.push(entry.timeslot.start.hours);
      hours.push(entry.timeslot.end.hours);
    });

    hours.sort((a, b) => a - b);
    const minTime = hours[0];
    const maxTime = hours[hours.length - 1];

    for (let i = minTime; i <= maxTime; i++) {
      this.hours.push(i);
    }
  }

  getRow(rowEntry: RowEntry): string {
    const startTime = rowEntry.timeslot.start;
    const endTime = rowEntry.timeslot.end;

    const startIndex = this.hours.findIndex(time => time == startTime.hours);
    const endIndex = this.hours.findIndex(time => time == endTime.hours);

    const minuteStartOffset = Math.round(startTime.minutes / 5);
    const minuteEndOffset = Math.round(endTime.minutes / 5);

    if (minuteStartOffset != 0) this.offsetHours.push(startTime.hours);
    if (minuteEndOffset != 0) this.offsetHours.push(endTime.hours);

    return ((startIndex * this.rowOffset + 2) + minuteStartOffset)
      + "/"
      + ((endIndex * this.rowOffset + 2) + minuteEndOffset);
  }

  getColumn(rowEntry: RowEntry): string {
    const day = rowEntry.timeslot.date;

    return (this.days.findIndex(dayEntry => dayEntry.toString() == day.toString()) + 2).toString();
  }

  showTimetableEntry($event: MouseEvent, id: number) {
    $event.preventDefault();
    this.router.navigate(['timetableEntries', id]);
  }
}

class TimetableEntry {
  rowEntry: RowEntry;
  row: string;
  column: string;

  constructor(rowEntry: RowEntry, row: string, column: string) {
    this.rowEntry = rowEntry;
    this.row = row;
    this.column = column;
  }
}
